import {$ssoPost} from '@front/hooks';

export function ssoLogin(data) {
  return $ssoPost(`/v1/login`, data).then(res => {
    // setToken(res.token);
    return res;
  });
}

export function appleLogin(data) {
  return $ssoPost(`/v1/appQuickLogin`, data).then(res => {
    return res;
  });
}

// export function appRegister(data) {
//   return $ssoPost(`/v1/appQuickLogin`, data).then(res => {
//     return res;
//   });
// }
